import { Component } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
export class FormlyFieldCheckbox extends FieldType {
/**
 * @param {?} model
 * @param {?} field
 * @return {?}
 */
static createControl(model: any, field: FormlyFieldConfig): AbstractControl {
    return new FormControl(
      { value: model ? 'on' : undefined, disabled: field.templateOptions.disabled },
      field.validators ? field.validators.validation : undefined,
      field.asyncValidators ? field.asyncValidators.validation : undefined,
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-field-checkbox',
  template: `
    <label class="custom-control custom-checkbox">
      <input type="checkbox" [formControl]="formControl"
        *ngIf="!to.hidden" value="on"
        [formlyAttributes]="field" class="custom-control-input">
        {{ to.label }}
        <span class="custom-control-indicator"></span>
    </label>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormlyFieldCheckbox_tsickle_Closure_declarations() {
/** @type {?} */
FormlyFieldCheckbox.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyFieldCheckbox.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
